import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const aiPlatformPlugin = createPlugin({
  id: 'ai-platform',
  routes: {
    root: rootRouteRef,
  },
});

export const AiPlatformPage = aiPlatformPlugin.provide(
  createRoutableExtension({
    name: 'AiPlatformPage',
    component: () =>
      import('./components/AiPlatformPage').then(m => m.AiPlatformPage),
    mountPoint: rootRouteRef,
  }),
);
